import React from "react";
import { Box, Dialog, DialogActions, Typography } from "@mui/material";
import { EGInput } from "../../../../MainComponents/Input/EGInput";
import { EGButton } from "../../../../MainComponents/Button/EGButton/EGButton";
import { useTranslation } from "react-i18next";
/** Dialog to confirm custom filter name */
export const CustomFilterName = ({
  open,
  onClose,
  filterName,
  setFilterName,
  onConfirm,
}) => {
  const [t] = useTranslation("report");
  // Cancel process and close
  const handleCancel = () => {
    setFilterName("");
    onClose();
  };
  // Request confirm
  const handleConfirm = async () => {
    await onConfirm();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      maxWidth="xs"
      fullWidth
      disableEnforceFocus
      disableAutoFocus
      disableRestoreFocus
    >
      {/* Title */}
      <Typography variant="h6" py={2} textAlign={"center"}>
        {t("ReportsList.name_and_save_filter")}
      </Typography>
      {/* Subtitle */}
      <Box px={2}>
        <EGInput
          autoFocus
          autoComplete="off"
          label={`${t("ReportsList.filter_set_title")}: ${
            filterName.length
          }/100`}
          placeholder={t("ReportsList.eg_weekly_tracking_filters")}
          value={filterName}
          onChange={(e) => setFilterName(e.target.value)}
          inputProps={{ maxLength: 100 }}
          multiline
          rows={2}
        />
      </Box>
      {/* Action buttons */}
      <DialogActions sx={{ px: 1.5, py: 2 }}>
        <EGButton
          onClick={handleCancel}
          color="secondary"
          label={t("Filter.cancel")}
        />
        <EGButton
          onClick={handleConfirm}
          disabled={filterName.trim() === ""}
          color="primary"
          label={t("Filter.save_and_apply")}
          iconName={filterName.trim() === "" ? "" : "check_circle"}
        />
      </DialogActions>
    </Dialog>
  );
};
